<template>
  <div class="additional-counselors">
    <ol>
      <li
        v-for="(item,idx) in tagCloud"
        :key="idx"
      >
        <link-button
          :link="null"
          :buttonFace="`#${item.display_label}`"
          design="ghost"
          class="btn1"
          @click="$emit('click', item.id)"
        />
      </li>
    </ol>
  </div>
</template>

<script>
import LinkButton from '@/utvStore/components/partials/LinkButton'

export default {
  name: 'TagCloud',
  components: {
    LinkButton
  },
  props: {
    tagCloud: {
      type: Array,
      require: true,
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.additional-counselors {
  margin: 6.4% 5.333% 12.8%;
  > ol {
    padding: 0;
    margin: 0 -2.388% -2.388% 0;
    > li {
      list-style: none;
      margin: 0;
      padding: 0 2.388% 2.388% 0;
      display: inline-block;
    }
  }
  .btn1 {
    font-size: unquote('min(3.2vw, 18px)');
    padding: unquote('min(2.933vw, 17px) min(3.733vw, 21px)');
    line-height: 1.166;
    &::before {
      margin: 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/TagCloud.vue